import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../..";
import Colors from "../../../constants/Colors";
import {
  ScheduleDay,
  ScheduleTime,
  ScheduleTimeAvailableData,
} from "../../../core/http/service/SchedulingService";
import { setSelectedTimeAvailable } from "../../../store/actions/scheduling";
import { SubTitleSimple } from "../../UI/generalLayout/Layout.styled";
import {
  DayContainer,
  HourCard,
  HoursContainer,
  TimeContainer,
} from "../SchedulingCard.style";

// import { Container } from './styles';

export interface DaySchedulingCardProp {
  day: ScheduleDay;
  scheduleTimeAvailableData: ScheduleTimeAvailableData;
}

const convertDay = (day: string) => {
  const dayArray = day.split("-");
  return `${dayArray[2]}/${dayArray[1]}/${dayArray[0]}`;
};

const DaySchedulingCard: React.FC<DaySchedulingCardProp> = ({
  day,
  scheduleTimeAvailableData,
}) => {
  const dispatch = useAppDispatch();
  const { pacienteId, empresaId } = useSelector((state: any) => state.scheduling);

  const onClickHour = async (time: ScheduleTime) => {
    await dispatch(
      setSelectedTimeAvailable(scheduleTimeAvailableData, day, time, pacienteId, empresaId)
    );
  };

  return (
    <TimeContainer key={day.dia}>
      <DayContainer>
        <SubTitleSimple color={Colors.SPM800}>
          {convertDay(day.dia)}
        </SubTitleSimple>
        {/* <SubTitleSimple color={Colors.SPM800}>13/12/22</SubTitleSimple> */}
      </DayContainer>
      <HoursContainer>
        {day.horarios.map((time) => (
          <HourCard onClick={() => onClickHour(time)} key={time.id}>
            <SubTitleSimple color={Colors.SPM800}>
              {time.horario.substring(0, 5)}
            </SubTitleSimple>
          </HourCard>
        ))}
      </HoursContainer>
    </TimeContainer>
  );
};

export default DaySchedulingCard;
